import { getRootElement } from "@phn/utility/helper";
import { motionDurationShort } from "@porsche-design-system/components-js/styles";
import animationManager, {
  AnimationEndsCallbacks,
  makeSequence,
} from "../../../../../../shared/services/animation-manager";
import { AnimationSequences } from "../../../../../../shared/utility/constants";

const firstDrawer = "phn-nd-single-drawer .drawer:not(.animating)";
export default function registerTransitionNextLevelSingleDrawerAnimation({
  onAnimationEnds,
}: AnimationEndsCallbacks): void {
  animationManager.register(
    AnimationSequences.TRANSITION_NEXT_LEVEL_SINGLE_DRAWER,
    makeSequence([
      [
        {
          elementSelector: firstDrawer,
          animation: {
            className: "translate-backward-animation-out",
          },
          onEnd: () => {
            // Stay hidden after animation
            const elem = getRootElement().querySelector(firstDrawer);
            if (elem) (elem as HTMLElement).style.opacity = "0";
          },
        },
        {
          onStart: async () => {
            await new Promise((resolve) => {
              setTimeout(
                resolve,
                Number(motionDurationShort.replace("s", "")) * 1000,
              );
            });
          },
          elementSelector: "phn-nd-single-drawer .drawer.animating",
          animation: {
            className: "mobile-transition-forward",
          },
          onEnd: onAnimationEnds,
        },
      ],
    ]),
  );
}
